export * from './EcoLabelItem';
